import { useState, useEffect, createRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

let cachedCountryCode = null;
let fetchCountryPromise = null;

export const useCountry = () => {
  const backendApiUrl = process.env.REACT_APP_BACKEND_URL;
  const [countryCode, setCountryCode] = useState(cachedCountryCode || "");

  useEffect(() => {
    if (cachedCountryCode) {
      setCountryCode(cachedCountryCode);
      return;
    }

    if (!fetchCountryPromise) {
      fetchCountryPromise = (async () => {
        const getCountryFromIP = async () => {
          try {
            const data = await fetch("https://ipapi.co/json/").then((r) => r.json());
            return data?.country_code?.toLowerCase() || null;
          } catch {
            return null;
          }
        };

        const getCountryFromBackend = async () => {
          try {
            const res = await fetch(`${backendApiUrl}api/v1/business/getCountryCodePhoneCode`);
            const { result } = await res.json();
            return result?.countryCode?.toLowerCase() || null;
          } catch (e) {
            console.error("Error fetching country from backend:", e);
            return null;
          }
        };

        const getCountryFromTimezone = () => {
          try {
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone?.split("/")[1] || "";
            const tzMap = {
              Kolkata: "in",
              London: "gb",
              "New_York": "us",
              Dubai: "ae",
              Tokyo: "jp",
              Sydney: "au",
            };
            return tzMap[tz] || null;
          } catch {
            return null;
          }
        };

        const detected =
          (await getCountryFromBackend()) ||
          (await getCountryFromIP()) ||
          getCountryFromTimezone() ||
          "in";

        cachedCountryCode = detected;
        return detected;
      })();
    }

    fetchCountryPromise.then((detected) => {
      setCountryCode(detected);
    });

  }, [backendApiUrl]);

  return { countryCode };
};

export const ScrollToTop = ()=> {
  const { pathname } = useLocation();

 useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", 
    });
  }, [pathname]);

  return null;
}

export const formRef = createRef();

export const scrollToForm = () => {
  if (!formRef.current) return;
  const top = formRef.current.getBoundingClientRect().top + window.scrollY - 100;
  // window.scrollTo({ top, behavior: "smooth" });
   const rect = formRef.current.getBoundingClientRect();
  const formBottom = rect.bottom + window.scrollY - 80;
   const viewportHeight = window.innerHeight;
   const scrollPosition = formBottom - viewportHeight;
     window.scrollTo({
    top: window.innerWidth <= 1024 ? scrollPosition : top,
    behavior: "smooth",
  });
};








const API_BASE_URL = process.env.REACT_APP_BLOG_API_URL;

// Common API function
const apiRequest = async (endpoint) => {
  try {
    const { data, status, statusText } = await axios.get(`${API_BASE_URL}api/v1/user/${endpoint}`);

    if (status !== 200) {
      throw new Error(`Error: ${status} - ${statusText}`);
    }

    return data?.data;
  } catch (error) {
    console.error("API Error:", error?.response?.data?.message || error.message);
    throw error;
  }
};

// APIs
export const getAllBlogs = (type = "bb") =>
  apiRequest(`get-all-blogs?type=${type}`);

export const getBlogById = (slug, type = "bb") =>
  apiRequest(`get-blog-by-slug?slug=${slug}&type=${type}`);

export const getPopularBlogs = (type = "bb") =>
  apiRequest(`get-random-blog-by-type?type=${type}`);



export function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }


export  const stripHtml = (html) => {
  return html?.replace(/<[^>]*>?/gm, "");
};